import { Link, Outlet } from 'react-router';
import { canUseWaiterSurface, roleHome } from '@/auth/roles';
import { useStaffSession } from '@/auth/react';
import { buttonClasses } from '@/components/Button';
import { EmptyState } from '@/components/EmptyState';
import { StaffHeader } from '@/shells/StaffHeader';

/**
 * Waiter screens are for waiters and branch managers. Any other role sees "Not allowed" under the plain
 * header, with no waiter navigation, and no waiter request is made: the screens below are not even
 * mounted. A hint for what to show; the backend still decides.
 */
export function StaffGate() {
  const role = useStaffSession()?.user.role;
  if (!role) return null;
  if (!canUseWaiterSurface(role)) {
    return (
      <div className="flex min-h-dvh flex-col bg-canvas">
        <StaffHeader title="Waiter" />
        <main id="main" tabIndex={-1} className="flex-1 px-4 pt-4 pb-6 md:px-6">
          <EmptyState
            icon="alert"
            title="Not allowed"
            message="You don't have access to the waiter screens."
            action={
              <Link to={roleHome(role)} className={buttonClasses({ variant: 'secondary' })}>
                Go to your home screen
              </Link>
            }
          />
        </main>
      </div>
    );
  }
  return <Outlet />;
}

/** A wrong address inside the waiter area: the shell and its tabs stay, and the way back is the floor. */
export function StaffNotFound() {
  return (
    <EmptyState
      icon="alert"
      title="Page not found"
      message="That page doesn't exist."
      action={
        <Link to="/staff" className={buttonClasses({ variant: 'secondary' })}>
          Back to the floor
        </Link>
      }
    />
  );
}
